module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/bookmark-39a8cfb9317d15f98fae2b491f710b6e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/bookmark.svg
// module id = tHvK
// module chunks = 24